module.exports = __webpack_public_path__ + "static/img/lunbo2.8de5e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/lunbo/lunbo2.png
// module id = WEI/
// module chunks = 6